/** @jsxImportSource @emotion/react */

import { Interpolation, Theme, css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import makeProductPricePresentation, {
  ProductPricePresentationProps,
} from './makeProductPricePresentation'
import { tokubaiprice } from '../fonts/TokubaiPriceFontFace'

type Props = {
  product: ProductPricePresentationProps
  wrapperStyle?: Interpolation<Theme>
}

export default function ProductPrice({ product, wrapperStyle }: Props): ReactElement {
  const pricePresentation = makeProductPricePresentation(product)
  const productPriceStyle = wrapperStyle

  return (
    <Fragment>
      {pricePresentation.main.length > 0 && (
        <div css={productPriceStyle}>
          <div css={productMainPriceStyle}>
            {pricePresentation.main.map((presentation, key) => {
              const text = presentation.code || presentation.text
              if (presentation.size === 'large') {
                return (
                  <span key={key} css={productPriceLargeNoteStyle}>
                    {text}
                  </span>
                )
              } else {
                return <span key={key}>{text}</span>
              }
            })}
          </div>
          {pricePresentation.sub && (
            <div css={productSubPriceStyle}>{pricePresentation.sub.text}</div>
          )}
        </div>
      )}
    </Fragment>
  )
}

const productMainPriceStyle = css`
  ${tokubaiprice}
  font-size: 14px;
  line-height: 24px;
  color: #ea1930;
`

const productPriceLargeNoteStyle = css`
  font-size: 24px;
`

const productSubPriceStyle = css`
  margin-top: 4px;
  color: #707060;
  font-size: 12px;
  line-height: 12px;
`
